
/**
 * Easing Functions
 * 0 or 1 はこの呼び出す前にfromとtoで返すようにする
 */
type EasingFunctionsType = {
    [key: string]: Function;
}
const EASING_FUNCTIONS: EasingFunctionsType = {
    // basic type
    linear: (value: number) => {        
        return value;
    },

    // quad
    easeInQuad: (value: number) => {
        return value * value;
    },
    easeOutQuad: (value: number) => {
        return value * (2 - value);
    },
    easeInOutQuad: (value: number) => {
        return value < 0.5 ? 2 * value * value : -1 + (4 - 2 * value) * value;
    },  

    // expo
    easeInExpo: (value: number) => {
        return Math.pow(2, 10 * (value - 1));
    },
    easeOutExpo: (value: number) => {
        return 1 - Math.pow(2, -10 * value);
    },
    easeInOutExpo: (value: number) => {
        return value < 0.5 ? Math.pow(2, 20 * value - 10) / 2 : (2 - Math.pow(2, -20 * value + 10)) / 2;
    },

    // customized easing
    teleport: (value: number, visibleRange: number = 0.05) => {
        if(value < 0.5) {            
            // return EASING_FUNCTIONS.easeInQuad(value / 0.5) * visibleRange;
            // パフォーマンス最適化のためにインラインで展開
            return value * value * 4 * visibleRange;
        } else {
            // const _value = (value - 0.5) / 0.5;
            // return (1 - visibleRange) + EASING_FUNCTIONS.easeOutQuad((value - 0.5) / 0.5) * visibleRange;
            // パフォーマンス最適化のためにインラインで展開
            const _value = 2 * value - 1;
            return (1 - visibleRange) + _value * (2 - _value) * visibleRange;
        }
    },
    teleportOut: (value: number, visibleRange: number = 0.5) => {
        // return (1 - visibleRange) + visibleRange * EASING_FUNCTIONS.easeOutQuad(value);
        // パフォーマンス最適化のためにインラインで展開
        return (1 - visibleRange) + visibleRange * value * (2 - value);
    },

    // combination
    comboTest: (value: number) => {
        const quad = EASING_FUNCTIONS.easeOutQuad?.(value) || 0;
        const expo = EASING_FUNCTIONS.easeOutExpo?.(quad * quad) || 0;
        return expo;
    }
}

export type Easing = keyof typeof EASING_FUNCTIONS;
export default EASING_FUNCTIONS;